// src/context/SymbolContext.js
//
// Fetches ALL symbols once when the app boots.
// Any component can call useSymbols() to get the list instantly —
// no extra API calls, no loading spinners inside the search dialog.

import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchAllSymbols } from "../services/symbolService";

const SymbolContext = createContext({
  symbols: [],
  loading: true,
  error: null,
});

export function SymbolProvider({ children }) {
  const [symbols, setSymbols] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log("SymbolProvider mounted, fetching symbols...");
    fetchAllSymbols()
      .then((data) => {
        setSymbols(data);
      })
      .catch((err) => {
        console.error("Failed to load symbols:", err);
        setError("Could not load symbols from server.");
      })
      .finally(() => {
        setLoading(false);
      });
  }, []); // runs once on mount

  return (
    <SymbolContext.Provider value={{ symbols, loading, error }}>
      {children}
    </SymbolContext.Provider>
  );
}

// Custom hook — use this in any component
export function useSymbols() {
  return useContext(SymbolContext);
}